import { getCookie, setCookie } from './cookies';
import { loadFromAPIs } from './fetch';
import { uefaApiBaseUrl } from './WindowContext';

export type D3Country = {
  countryName: string;
  countryCode: string;
  countryCodeShort: string;
  fifaCountryCode: string;
  regionCodeShort: string;
  uefaCountry: boolean;
};

const cookieName = 'geo.Country';
export const getCountry = async (signal?: AbortSignal): Promise<D3Country> => {
  let country = getCookie(cookieName) as D3Country;

  if (country?.countryCodeShort) return country;

  country = await loadFromAPIs<D3Country>('/countries', {}, { apiUrl: uefaApiBaseUrl, signal });

  if (!country || Array.isArray(country)) return null;

  setCookie(cookieName, country, {
    path: '/',
    domain: location.hostname === 'localhost' ? 'localhost' : '.uefa.com',
  });

  return country;
};

const d3 = (window.D3 ??= {});
d3.getCountry ??= getCountry;
